import { createSelector } from 'reselect';
import { Immutable } from 'seamless-immutable';

import { Model, ReduxState, UseFormData } from '../types';

const selectFormData = (state: ReduxState): UseFormData | undefined => state.form;
const selectModels = (
	state: ReduxState,
): { [key: string]: Immutable<Model<string> | undefined> } | undefined => selectFormData(state)?.models;

export const selectModel = (key: string): ((state: ReduxState) => Model<string>) =>
	createSelector(selectModels, models => {
		const model = models?.[key] ?? {};
		return model ? { ...model } : model;
	});
